import { createSlice } from "@reduxjs/toolkit";

const CUSTOMER_STORAGE_KEY = "customerAuthData";

// Helper to load specifically the CUSTOMER data
const loadCustomerFromStorage = () => {
  try {
    const storedAuth = localStorage.getItem(CUSTOMER_STORAGE_KEY);
    if (storedAuth) {
      const parsedAuth = JSON.parse(storedAuth);
      return {
        user: parsedAuth.user,
        token: parsedAuth.access_token,
        isAuthenticated: true,
      };
    }
  } catch (error) {
    console.error("Failed to load customer auth", error);
  }
  return {
    user: null,
    token: null,
    isAuthenticated: false,
  };
};

const initialState = loadCustomerFromStorage();

const customerAuthSlice = createSlice({
  name: "customerAuth", // Unique name for the store
  initialState,
  reducers: {
    setCustomerCredentials: (state, action) => {
      const { user, access_token } = action.payload;
      state.user = user;
      state.token = access_token;
      state.isAuthenticated = true;

      // Save with a unique key for customers
      localStorage.setItem(
        CUSTOMER_STORAGE_KEY,
        JSON.stringify(action.payload)
      );
    },
    logOutCustomer: (state) => {
      state.user = null;
      state.token = null;
      state.isAuthenticated = false;

      // Clear only customer data
      localStorage.removeItem(CUSTOMER_STORAGE_KEY);
      localStorage.removeItem("cartItems");
    },
  },
});

export const { setCustomerCredentials, logOutCustomer } =
  customerAuthSlice.actions;

export default customerAuthSlice.reducer;

// Selectors
export const selectCurrentCustomer = (state) => state.customerAuth.user;
export const selectCustomerToken = (state) => state.customerAuth.token;
